<template>
    <el-container class="layout-container">
        <!-- 顶部导航 -->
        <el-header class="app-header">
        </el-header>


        <!-- 主内容区 -->
        <el-main class="app-main">
            <div class="app-container">
                <div class="menu">
                    <div class="menu-container">
                        <!-- 一级菜单 -->
                        <div class="first-level-menu">
                            <div v-for="(item, index) in menuData" :key="index"
                                :class="['first-level-item', { active: activeFirstLevel === index }]"
                                @click="selectFirstLevel(index)">
                                <!-- 文字部分 -->
                                <div class="menu-text">{{ item.name }}</div>
                                <!-- 箭头图标（除了总体结果） -->
                                <div v-if="index > 0" class="arrow-icon"
                                    :class="{ 'arrow-up': activeFirstLevel === index, 'arrow-down': activeFirstLevel !== index }">
                                </div>
                            </div>
                        </div>

                        <!-- 二级菜单（仅在非"总体结果"时显示） -->
                        <div v-if="activeFirstLevel > 0" class="second-level-menu">
                            <div class="scroll-wrapper">
                                <div v-for="(subItem, subIndex) in menuData[activeFirstLevel].children" :key="subIndex"
                                    :class="['second-level-item', { active: activeSecondLevel === subIndex }]"
                                    @click="selectSecondLevel(subIndex)">
                                    {{ subItem.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <SecondRule />
                </div>
                <div class="second-rule-divider"></div>
                <!-- 使用栅格布局，设置不同的span值展示不同效果 -->
                <el-row :gutter="20" style="margin-bottom: 20px;">
                    <el-col :span="6">
                        <ReportStyle1 />
                    </el-col>
                    <el-col :span="8">
                        <ReportStyle2 />
                    </el-col>
                    <el-col :span="10">
                        <ReportStyle3 />
                    </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-bottom: 20px;">
                    <!-- 每行3列布局（span=8）-->
                    <el-col :span="8">
                        <ReportStyle3 />
                    </el-col>
                    <el-col :span="8">
                        <ReportStyle2 />
                    </el-col>
                    <el-col :span="8">
                        <ReportStyle1 />
                    </el-col>
                </el-row>


                <el-row :gutter="20" style="margin-bottom: 20px;">
                    <!-- 混合列布局（不同的span值）-->
                    <el-col :span="8">
                        <ReportStyle3 />
                    </el-col>
                    <el-col :span="16">
                        <ReportStyle4 />
                    </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-bottom: 20px;">
                    <!-- 每行1列布局（span=24）-->
                    <el-col :span="24">
                        <ReportStyle4 />
                    </el-col>
                </el-row>
            </div>
            
            <!-- 详情弹窗组件 -->
            <DetailModal 
                :visible.sync="showModal" 
                :data="modalData"
                @close="closeModal"
            />
            
            <!-- 测试按钮 - 用于演示弹窗功能 -->
            <button @click="openModal" style="position: fixed; bottom: 20px; right: 20px; z-index: 1000; padding: 10px 20px; background: rgba(5, 133, 247, 0.8); color: white; border: none; border-radius: 4px; cursor: pointer;">测试弹窗</button>
        </el-main>
    </el-container>

</template>

<script>
import { mapMutations } from 'vuex'
import SecondRule from './components/SecondRule.vue';
import ReportStyle1 from './components/reportStyle1.vue';
import ReportStyle2 from './components/reportStyle2.vue';
import ReportStyle3 from './components/reportStyle3.vue';
import ReportStyle4 from './components/reportStyle4.vue';
import DetailModal from './components/DetailModal.vue';
export default {
    components: {
        ReportStyle1, ReportStyle2, ReportStyle3, ReportStyle4, SecondRule, DetailModal,
    },
    data() {
        return {
            // 菜单数据
            menuData: [
                {
                    name: '总体结果',
                    // 总体结果没有子菜单
                },
                {
                    name: '一级维度1',
                    children: [
                        { name: '二级维度1-1' },
                        { name: '二级维度1-2' },
                        { name: '二级维度1-3' },
                        { name: '二级维度1-4' },
                        { name: '二级维度1-5' },
                        { name: '二级维度1-6' },
                        { name: '二级维度1-7' },
                        { name: '二级维度1-8' }
                    ]
                },
                {
                    name: '一级维度2',
                    children: [
                        { name: '二级维度2-1' },
                        { name: '二级维度2-2' },
                        { name: '二级维度2-3' },
                        { name: '二级维度2-4' },
                        { name: '二级维度2-5' },
                        { name: '二级维度2-6' },
                        { name: '二级维度2-7' }
                    ]
                },
                {
                    name: '一级维度3',
                    children: [
                        { name: '二级维度3-1' },
                        { name: '二级维度3-2' },
                        { name: '二级维度3-3' },
                        { name: '二级维度3-4' },
                        { name: '二级维度3-5' },
                        { name: '二级维度3-6' },
                        { name: '二级维度3-7' },
                        { name: '二级维度3-8' },
                        { name: '二级维度3-9' }
                    ]
                },
                {
                    name: '一级维度4',
                    children: [
                        { name: '二级维度4-1' },
                        { name: '二级维度4-2' },
                        { name: '二级维度4-3' },
                        { name: '二级维度4-4' },
                        { name: '二级维度4-5' },
                        { name: '二级维度4-6' }
                    ]
                },
                {
                    name: '一级维度5',
                    children: [
                        { name: '二级维度5-1' },
                        { name: '二级维度5-2' },
                        { name: '二级维度5-3' },
                        { name: '二级维度5-4' },
                        { name: '二级维度5-5' },
                        { name: '二级维度5-6' },
                        { name: '二级维度5-7' }
                    ]
                },
                {
                    name: '一级维度6',
                    children: [
                        { name: '二级维度6-1' },
                        { name: '二级维度6-2' },
                        { name: '二级维度6-3' },
                        { name: '二级维度6-4' },
                        { name: '二级维度6-5' },
                        { name: '二级维度6-6' },
                        { name: '二级维度6-7' },
                        { name: '二级维度6-8' }
                    ]
                },
                {
                    name: '一级维度7',
                    children: [
                        { name: '二级维度7-1' },
                        { name: '二级维度7-2' },
                        { name: '二级维度7-3' },
                        { name: '二级维度7-4' },
                        { name: '二级维度7-5' },
                        { name: '二级维度7-6' }
                    ]
                }
            ],
            // 当前选中的一级菜单索引
            activeFirstLevel: 0,
            // 当前选中的二级菜单索引
            activeSecondLevel: 0,
            // 弹窗显示状态
            showModal: false,
            // 弹窗数据
            modalData: {
                title: '正向证据',
                videoUrl: '',
                problemDescription: '教师在整节课中始终围绕“名字里的故事”这一核心教学内容，结合教材意图和课后练习要求，设定了清晰、具体、可操作的教学目标。例如，在导入阶段(00:26-05:12)，教师通过引导学生猜测自己的名字由来，激发学生的...',
                evidenceList: [
                    { id: 'EV001', type: '视频证据', time: '2024-01-15 14:30', status: '已确认' },
                    { id: 'EV002', type: '音频证据', time: '2024-01-15 14:35', status: '待确认' },
                    { id: 'EV003', type: '图像证据', time: '2024-01-15 14:40', status: '已确认' },
                    { id: 'EV004', type: '文本证据', time: '2024-01-15 14:45', status: '待确认' },
                    { id: 'EV005', type: '传感器数据', time: '2024-01-15 14:50', status: '已确认' },
                    { id: 'EV006', type: '日志记录', time: '2024-01-15 14:55', status: '待确认' },
                    { id: 'EV007', type: '网络数据', time: '2024-01-15 15:00', status: '已确认' },
                    { id: 'EV008', type: '系统截图', time: '2024-01-15 15:05', status: '待确认' },
                    { id: 'EV009', type: '操作记录', time: '2024-01-15 15:10', status: '已确认' },
                    { id: 'EV010', type: '异常报告', time: '2024-01-15 15:15', status: '待确认' }
                ],
                chartData: {}
            }
        }
    },
    mounted() {
        // 默认选中第一个一级菜单和其子菜单（如果有）
        if (this.activeFirstLevel > 0 && this.menuData[this.activeFirstLevel].children.length > 0) {
            this.activeSecondLevel = 0;
            // 触发默认选中的二级菜单事件
            this.handleMenuClick(this.activeFirstLevel, this.activeSecondLevel);
        } else if (this.activeFirstLevel === 0) {
            // 触发总体结果的点击事件
            this.handleMenuClick(0, -1);
        }
    },
    methods: {
        ...mapMutations(['logout']),

        // 选择一级菜单
        selectFirstLevel(index) {
            this.activeFirstLevel = index;
            // 重置二级菜单选中状态
            this.activeSecondLevel = 0;
            // 触发菜单点击事件
            if (index > 0 && this.menuData[index].children.length > 0) {
                this.handleMenuClick(index, 0);
            } else {
                this.handleMenuClick(index, -1);
            }
        },

        // 选择二级菜单
        selectSecondLevel(index) {
            this.activeSecondLevel = index;
            // 触发菜单点击事件
            this.handleMenuClick(this.activeFirstLevel, index);
            // 更新弹窗标题为当前选中的二级指标名称
            this.modalData.title = this.menuData[this.activeFirstLevel].children[index].name;
            // 打开弹窗
            this.openModal();
        },

        // 处理菜单点击事件
        handleMenuClick(firstIndex, secondIndex) {
            // 这里可以添加具体的业务逻辑，例如加载对应的数据等
            console.log('点击了菜单:', {
                firstLevel: firstIndex,
                secondLevel: secondIndex,
                firstLevelName: this.menuData[firstIndex].name,
                secondLevelName: secondIndex >= 0 ? this.menuData[firstIndex].children[secondIndex].name : null
            });
        },

        // 打开弹窗
        openModal() {
            this.showModal = true;
        },

        // 关闭弹窗
        closeModal() {
            this.showModal = false;
        }
    }
}
</script>

<style scoped lang="less">
@header-height: 72px; // 顶部高度

@bg_color: #f5f7f9; //背景颜色
@top_bg-color: #ffffff; //顶部导航背景颜色
@sider_w: 200px; //侧边导航宽度
@sider_bg-color: #191A23; //侧边导航背景颜色

/* 引入阿里巴巴普惠体常规字体 */
@font-face {
    font-family: 'AlibabaPuHuiTi';
    src: url('../../assets/fonts/AlibabaPuHuiTi-3-55-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

/* 引入阿里巴巴普惠体粗体字体 */
@font-face {
    font-family: 'AlibabaPuHuiTi-Bold';
    src: url('../../assets/fonts/AlibabaPuHuiTi-3-85-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}

/* 全局字体设置 */
* {
    font-family: AlibabaPuHuiTi;
}


// 头部样式
.app-header {
    height: @header-height !important;
    background: transparent;
    padding: 0 20px;
    line-height: @header-height;
    position: relative;
}

// 布局容器样式
.layout-container {
    height: 100%;
    width: 100%;
    min-height: 100vh;
    background-image: url('../../assets/home/background.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    background-color: #f5f7f9; // 添加背景色作为图片无法覆盖区域的填充色
}



// 主内容区样式
.app-main {
    flex: 1;
    padding: 10px 20px;
    background: transparent;
    overflow: hidden;
    min-height: 0;
    height: calc(100vh - @header-height);
}

// 应用容器样式
.app-container {
    padding-bottom: 20px;
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(0, 28, 53, 0.1);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(5, 133, 247, 0.5);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(5, 133, 247, 0.8);
    }

    /* 确保栅格布局正常显示 */
    /* 栅格容器样式 */
    .el-row {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        overflow: visible;
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    /* 列样式增强 */
    .el-col {
        box-sizing: border-box;
        min-width: 0;
    }

    /* 为所有Report组件添加统一的容器样式 */
    .el-col>* {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        min-width: 0;
    }

    /* 防止文本溢出 */
    .text-content {
        word-wrap: break-word !important;
        word-break: break-all !important;
        overflow-wrap: break-word !important;
    }

    /* 菜单样式 */
    .menu {
        width: 100%;
        margin-bottom: 20px;
        padding: 10px;
        box-sizing: border-box;
    }

    .menu-container {
        width: 100%;
    }

    /* 一级菜单样式 */
    .first-level-menu {
        display: flex;
        flex-wrap: nowrap;
        // margin-bottom: 10px;
        overflow-x: auto;
        overflow-y: hidden;
        padding: 10px 20px;
        /* 隐藏滚动条但保留滚动功能 */
        scrollbar-width: thin;
        scrollbar-color: rgba(5, 133, 247, 0.5) transparent;
        background: linear-gradient(180deg, rgba(0, 28, 53, 0.28) 0%, rgba(0, 28, 53, 0.24) 101%);
        box-sizing: border-box;
        /* 123444 */
        border: 1px solid;
        border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;

    }

    /* 自定义一级菜单滚动条样式 */
    .first-level-menu::-webkit-scrollbar {
        height: 6px;
    }

    .first-level-menu::-webkit-scrollbar-track {
        background: transparent;
    }

    .first-level-menu::-webkit-scrollbar-thumb {
        background: rgba(5, 133, 247, 0.5);
        border-radius: 3px;
    }

    .first-level-menu::-webkit-scrollbar-thumb:hover {
        background: rgba(5, 133, 247, 0.8);
    }

    .first-level-item {
        width: 205px;
        height: 46px;
        margin-right: 10px;
        cursor: pointer;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        background-image: url(../../assets/image/menu-default.png);
        background-repeat: no-repeat;
        border-radius: 4px;
        font-size: 20px;
        transition: all 0.3s ease;
        white-space: nowrap;
        border: 1px solid transparent;
        box-sizing: border-box;
        position: relative;
    }

    /* 菜单文字样式 */
    .menu-text {
        // background: linear-gradient(180deg, #FFFFFF 100%, #9ED1FF 100%);
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
        // background-clip: text;
        // text-fill-color: transparent;
        font-weight: 500;
        color: #9ED1FF;
        font-size: 20px;
    }

    /* 箭头图标样式 */
    .arrow-icon {
        width: 16px;
        height: 16px;
        margin-left: 8px;
        transition: all 0.2s ease;
        background: url(../../assets/image/arrow.png) no-repeat center center;
    }

    .arrow-down {
        transform: rotate(180deg);
    }

    .arrow-up {
        transform: rotate(0deg);
    }


    .first-level-item.active {
        color: #9ED1FF;
        background-image: url(../../assets/image/menu-active.png);
        background-repeat: no-repeat;
    }

    /* 选中状态下的文字渐变效果 */
    .first-level-item.active .menu-text {
        color: #fff;
        font-weight: 500;
        // background: linear-gradient(180deg, #FFFFFF 100%, #9ED1FF 100%);
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
        // background-clip: text;
        // text-fill-color: transparent;
    }

    /* 二级菜单样式 */
    .second-level-menu {
        margin-top: 10px;
        background: rgba(0, 19, 37, 0.5);
        border-radius: 4px;
        padding: 10px;
    }

    .scroll-wrapper {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        padding-bottom: 5px;
        scrollbar-width: thin;
        scrollbar-color: rgba(5, 133, 247, 0.5) rgba(0, 28, 53, 0.1);
    }

    /* 自定义二级菜单滚动条 */
    .scroll-wrapper::-webkit-scrollbar {
        height: 6px;
    }

    .scroll-wrapper::-webkit-scrollbar-track {
        background: rgba(0, 28, 53, 0.1);
        border-radius: 3px;
    }

    .scroll-wrapper::-webkit-scrollbar-thumb {
        background: rgba(5, 133, 247, 0.5);
        border-radius: 3px;
    }

    .scroll-wrapper::-webkit-scrollbar-thumb:hover {
        background: rgba(5, 133, 247, 0.8);
    }

    .second-level-item {
        padding: 0px 10px;
        margin-right: 14px;
        cursor: pointer;
        color: #fff;
        border-radius: 4px;
        line-height: 32px;
        font-size: 14px;
        transition: all 0.3s ease;
        white-space: nowrap;
        background: rgba(86, 119, 160, 0.4);
        box-sizing: border-box;
        border: 1px solid;
        border-image: linear-gradient(180deg, #98C1F5 0%, #E3F4FF 100%) 1;
        box-shadow: inset 0px 4px 10px 0px rgba(89, 128, 178, 0.5), inset 0px -6px 20px 0px rgba(105, 139, 183, 0.7);
    }

    .second-level-item:hover {
        background: rgba(13, 80, 146, 0.4);
    }

    .second-level-item.active {

        background: rgba(4, 66, 145, 0.4);
        border-image: linear-gradient(180deg, #2F8BFF 0%, #E3F4FF 100%) 1;
        box-shadow: inset 0px 4px 10px 0px #044291, inset 0px -6px 20px 0px #3177CF;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .first-level-menu {
            flex-wrap: wrap;
        }

        .first-level-item {
            margin-bottom: 8px;
        }
    }
}

.second-rule-divider{
    background: url(../../assets/image/rule-divider.png) no-repeat center center;
    width: 100%;
    height: 20px;
    margin: 20px 0;
}

//二级指标
.second-rule-container {
    display: flex;
    flex-direction: column;
    background: rgba(0, 28, 53, 0.7);
    box-sizing: border-box;
    border: 1px solid;
    margin-bottom: 20px;
    border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;

    .header {
        height: 40px;
        background-color: rebeccapurple;
        width: 100%;
        background: linear-gradient(90deg, rgba(13, 80, 146, 0.5) 0%, rgba(13, 80, 146, 0.5) 100%);
        position: relative;

        .header-text {
            color: #ffffff;
            font-size: 20px;
            text-align: center;
            line-height: 40px;
            /* 与header高度一致，确保垂直居中 */
            background: url(.././../assets/image/rule-name-bg.png) no-repeat;
            width: 420px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }

        .second-rule-text {
            font-size: 18px;
            color: #FFFFFF;
            line-height: 34px;
        }
    }
}


</style>
